import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MonthPickerComponent} from './month-picker.component';
import {TextMaskModule} from 'angular2-text-mask';
import {CommonModule} from '@angular/common';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ClickOutsideModule} from '../../../events/click-outside/click-outside.module';
import {MonthSelectorComponent} from './selector/month-selector.component';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    imports: [CommonModule, FormsModule, TextMaskModule, NgbModule, ClickOutsideModule],
    declarations: [MonthPickerComponent, MonthSelectorComponent],
    exports: [MonthPickerComponent],
})
export class MonthPickerModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/controls/monthpicker/month-picker.module.ts